import { LOCALES } from "~/constants/locales";
import { TemplateType } from "../constants/template-type";
import { SkinType } from "../theme.type";
import { decamelizeKeys } from "humps";

export const serializeTemplate = (
  template?: Partial<SkinType>,
  lowerCase?: boolean,
  noDecamelize?: boolean,
): SkinType => {
  const convertKeys = (data: any): any => {
    if (Array.isArray(data)) {
      return data.map((item) => JSON.parse(JSON.stringify(item)));
    } else if (typeof data === "object" && data !== null) {
      const result: any = {};
      for (const [key, value] of Object.entries(data)) {
        const convertedKey = lowerCase ? key.toLowerCase() : key.toUpperCase();
        result[convertedKey] = key === "widgets" ? value : convertKeys(value);
      }
      return result;
    } else {
      return data;
    }
  };

  const convertedTemplate = noDecamelize ? template : decamelizeKeys(template);
  const result = convertKeys(convertedTemplate);

  return result as SkinType;
};

export const getHeaderByCover = (coverType: string) => {
  let newCover: Record<string, any> = {
    HEADER: TemplateType.NONE,
    COVER: coverType,
  };

  if (
    coverType === TemplateType.COVER_1 ||
    coverType === TemplateType.COVER_2
  ) {
    newCover = {
      ...newCover,
      HEADER: {
        SKIN: TemplateType.HEADER_4,
        PROPS: {
          OVER_BANNER: false,
          STICKY: true,
        },
      },
    };
  } else if (coverType === TemplateType.COVER_3) {
    newCover = {
      ...newCover,
      HEADER: {
        SKIN: TemplateType.HEADER_4,
        PROPS: {
          OVER_BANNER: true,
          STICKY: false,
        },
      },
    };
  } else if (
    coverType === TemplateType.COVER_4 ||
    coverType === TemplateType.COVER_6
  ) {
    newCover = {
      ...newCover,
      HEADER: {
        SKIN: TemplateType.HEADER_5,
        PROPS: {
          OVER_BANNER: false,
          STICKY: true,
        },
      },
    };
  } else if (
    coverType === TemplateType.COVER_5 ||
    coverType === TemplateType.COVER_7
  ) {
    newCover = {
      ...newCover,
      HEADER: {
        SKIN: TemplateType.HEADER_5,
        PROPS: {
          OVER_BANNER: true,
          STICKY: false,
        },
      },
    };
  }

  return newCover;
};

export const getGridByProductCard = (productCard: string) => {
  let newProductCard: Record<string, any> = {
    PRODUCTS_GRID: TemplateType.NONE,
    PRODUCT_CARD: productCard,
  };

  if (
    productCard === TemplateType.PRODUCT_CARD_1 ||
    productCard === TemplateType.PRODUCT_CARD_3 ||
    productCard === TemplateType.PRODUCT_CARD_4 ||
    productCard === TemplateType.PRODUCT_CARD_5
  ) {
    newProductCard = {
      ...newProductCard,
      PRODUCTS_GRID: TemplateType.PRODUCTS_GRID_3,
    };
  } else if (productCard === TemplateType.PRODUCT_CARD_2) {
    newProductCard = {
      ...newProductCard,
      PRODUCTS_GRID: TemplateType.PRODUCTS_GRID_5,
    };
  } else if (productCard === TemplateType.PRODUCT_CARD_6) {
    newProductCard = {
      ...newProductCard,
      PRODUCTS_GRID: TemplateType.PRODUCTS_GRID_2,
    };
  } else if (productCard === TemplateType.PRODUCT_CARD_7) {
    newProductCard = {
      ...newProductCard,
      PRODUCTS_GRID: TemplateType.PRODUCTS_GRID_1,
    };
  }

  return newProductCard;
};

export const getStoreLocale = (locale?: string) => {
  if (!locale) return LOCALES.ES;

  if (locale.includes(LOCALES.ES)) {
    return LOCALES.ES;
  } else if (locale.includes(LOCALES.EN)) {
    return LOCALES.EN;
  } else if (locale.includes(LOCALES.PT)) {
    return LOCALES.PTBR;
  } else {
    return LOCALES.ES;
  }
};
